function initSliderProductsBanners(id) {
  new Swiper(document.querySelector(`#${id} .swiper`), {
    slidesPerView: 1,
    speed: 1000,
    effect: 'fade',
    crossFade: true,
    loop: true,
    // pagination: {
    //   el: '.swiper-pagination',
    //   clickable: true,
    // },
    navigation: {
      nextEl: '.navigation .swiper-button-next-custom',
      prevEl: '.navigation .swiper-button-prev-custom',
    },
  });
}
